import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { ThemeName as r } from "@fcamna/shared-component-foundations";
import { c as I } from "./index-65016bfa.mjs";
import n, { css as t, useTheme as _ } from "styled-components";
import "react";
import { u as A } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { CloseButton as h } from "./closeButton.js";
import { Icon as f } from "./icon.js";
import { u as g } from "./useAccessibilityProps-2f24cf29.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./button.js";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
const L = {
  [r.FORD_PRO]: {
    information: "informationFilled",
    neutral: "informationFilled",
    warning: "warningFilled",
    error: "warningFilled",
    success: "checkmarkFilled"
  },
  [r.FORD_CREDIT]: {
    information: "information",
    neutral: "information",
    warning: "warning",
    error: "warning",
    success: "checkmarkRounded"
  }
}, y = n.div`
  &.InlineAlert {
    ${({
  theme: {
    components: { inLineAlert: e }
  }
}) => t(e.InlineAlert)};
  }
`, N = n(f)`
  &.InlineAlert__leading-icon {
    ${({
  theme: {
    components: { inLineAlert: e }
  }
}) => t(e.LeadingIcon)}
  }
`, C = n.div`
  &.InLineAlert__content {
    ${({
  theme: {
    components: { inLineAlert: e }
  }
}) => t(e.Content)}
  }
`, F = n.h1`
  &.InLineAlert__content-title {
    ${({
  theme: {
    components: { inLineAlert: e }
  }
}) => t(e.Title)}
  }
`, b = n.p`
  &.InLineAlert__content-body {
    ${({
  theme: {
    components: { inLineAlert: e }
  }
}) => t(e.Body)}
  }
`, w = n(h)`
  &.InlineAlert__close-btn {
    ${({
  theme: {
    components: { inLineAlert: e }
  }
}) => t(e.StyledCloseButton)}
  }
`, R = {
  information: "info",
  success: "success",
  warning: "caution",
  error: "danger",
  neutral: "default"
}, K = ({
  variant: e = "neutral",
  titleProp: i,
  body: m,
  onClickClose: l,
  accessibilityOptions: c,
  showLeadingIcon: a = !0
}) => {
  const p = A({ label: "Inline Alert" }), { themeName: d = r.FORD_CREDIT } = _(), u = g("alert", { ariaLive: "assertive", ariaAtomic: !0, ...c });
  return /* @__PURE__ */ s(
    y,
    {
      ...u,
      className: I(["InlineAlert", `InlineAlert--${e}`]),
      ...p,
      children: [
        a && /* @__PURE__ */ o(
          N,
          {
            className: "InlineAlert__leading-icon",
            size: "m",
            name: L[d][e]
          }
        ),
        /* @__PURE__ */ s(C, { className: "InLineAlert__content", children: [
          i && /* @__PURE__ */ o(
            F,
            {
              className: "InLineAlert__content-title",
              as: i.headingLevel || "h1",
              children: i.title
            }
          ),
          /* @__PURE__ */ o(b, { className: "InLineAlert__content-body", children: m })
        ] }),
        l && /* @__PURE__ */ o(
          w,
          {
            size: "xsmall",
            onClick: l,
            color: R[e],
            className: "InlineAlert__close-btn"
          }
        )
      ]
    }
  );
};
export {
  K as InLineAlert
};
